import { $form, $view } from 'signals/global.signals';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import UniversalInput from 'components/global/UniversalInput';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitResetPassword } from 'components/views/Login/_components/ForgotPasswordModal/ForgotPasswordModal.helpers';

const ForgotPasswordModal = () => (
  <SimpleModal
    show={$view.value.activeModal === 'forgot-password'}
    onHide={handleHideModal}
    enforceFocus={false}
    title="Forgot Your Password?"
    primaryButtonText="Reset Password"
    onPrimaryClick={handleSubmitResetPassword}
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value.isModalLoading}
  >
    <UniversalInput
      name="email"
      value={$form.value.email}
      placeholder="Email"
    />
  </SimpleModal>
);

export default ForgotPasswordModal;
